import React, { memo } from 'react';
import bem from 'utils/bem';
import { datetimeShortFromUTC } from 'utils/dayjs';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { Short3RowsTeaser } from 'components/SpecialistTeaser';
import {TextWithPulsingDot} from "components/TextWithPulsingDot";
import { GreenText } from 'components/GreenText';

const { el } = bem('order-form', 'form');
const OrderInfo = (props) => {
    const { problem, workingOffline, workingWithPairs, events, comment, specialist, onEditClick } = props;

    let city = null, district = null;
    const firstEvent = specialist.getEventByPK(events[0]);
    if (firstEvent.address) {
        city = firstEvent.address.town;
        district = firstEvent.address.district;
    }

    const problemText = problem ? problem : comment ? comment : 'Психологическое консультирование';
    const typeText = workingOffline ?
        'Очная встреча' :
        <TextWithPulsingDot hasBackground={true}>
            <GreenText>Онлайн-встреча</GreenText>
        </TextWithPulsingDot>;
    const pairText = workingWithPairs ? ', ' + 'работа с парой' : '';
    const cityText = `${ city ? city : 'Город не важен' }${ city && district ? ', ' + district : '' }`;
    const eventFormat = (pk) => {
        const utcDate = specialist.getEventByPK(pk).startDate;
        const { date, time } = datetimeShortFromUTC(utcDate);
        return `${ date } ${ time }`;
    };

    const eventSort = (a, b) => {
        const eventA = specialist.getEventByPK(a).startDate;
        const eventB = specialist.getEventByPK(b).startDate;
        return new Date(eventA).getTime() - new Date(eventB).getTime();
    }

    return (
        <div className={ el('final-step') }>
            <div className={ el('content-block') }>
                <div className={ el('order-block') }>
                    <div className={ el('order-header') }>
                        <Text className={ el('order-title') } tag={ 'div' } serif>Ваша запись</Text>
                        <div className={ el('edit') } onClick={ onEditClick }>
                            <Icon name={ 'pencil' }/>
                            <Text>Редактировать</Text>
                        </div>
                    </div>
                </div>
                <div className={ el('details') }>
                    <div className={ el('detail') }>
                        <div className={ el('detail-label') }>
                            <Text>Запрос</Text>
                        </div>
                        <div className={ el('detail-value') }>
                            <Text>{ problemText }</Text>
                        </div>
                    </div>
                    <div className={ el('detail') }>
                        <div className={ el('detail-label') }>
                            <Text>Тип</Text>
                        </div>
                        <div className={ el('detail-value') }>
                            <Text>{ typeText }{ pairText }</Text>
                        </div>
                    </div>
                    { workingOffline && <div className={ el('detail') }>
                        <div className={ el('detail-label') }>
                            <Text>Город</Text>
                        </div>
                        <div className={ el('detail-value') }>
                            <Text>{ cityText }</Text>
                        </div>
                    </div> }
                </div>
                <div className={ el('events-block') }>
                    <Short3RowsTeaser specialist={ specialist }/>
                    <div className={ el('separator') }/>
                    <div className={ el('events-list') }>
                        { events.sort(eventSort).map((event, i) => <div key={ i } className={ el('event-detail') }>
                                <Text className={ el('event-detail-number') }>#{ i + 1 }</Text>
                                <Text className={ el('event-detail-date') }>{ eventFormat(event) }</Text>
                            </div>
                        ) }
                    </div>
                    <div className={el('moscow-time')}>
                        <Icon name={'warning-circle'} />
                        <Text>Время начала консультаций указано по Московскому времени</Text>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(OrderInfo);
